import axios from "axios";

export const API = `${process.env.REACT_APP_BACKEND_URL}/api/agency`;
export const BACKEND = process.env.REACT_APP_BACKEND_URL;
const KEY = "agencyToken";

export const getToken = () => localStorage.getItem(KEY);
export const setToken = (t) => (t ? localStorage.setItem(KEY, t) : localStorage.removeItem(KEY));

export const authHeaders = () => {
  const t = getToken();
  return t ? { headers: { Authorization: `Bearer ${t}` } } : {};
};

export const api = axios.create();
api.interceptors.request.use((cfg) => {
  const t = getToken();
  if (t) cfg.headers.Authorization = `Bearer ${t}`;
  return cfg;
});

export const DOC_TYPE_LABELS = {
  id_passport: "Passport / photo ID",
  proof_of_address: "Proof of address",
  payslip: "Payslip",
  bank_statement_personal: "Personal bank statement",
  deposit_source: "Deposit / source of funds",
  self_employed_income: "Self-employed income evidence",
  bank_statement_business: "Business bank statement",
  annual_accounts: "Annual accounts",
  management_accounts: "Management accounts",
  cash_flow: "Cash-flow forecast",
  existing_borrowing: "Existing borrowing statement",
  property_rental: "Property / rental documents",
  other: "Other document",
};

export const APP_TYPE_LABELS = {
  res_mortgage: "Residential mortgage",
  btl_mortgage: "Buy-to-let mortgage",
  business_loan: "Business loan",
  other: "Other finance enquiry",
};

export const INTERNAL_STAGE_LABELS = {
  new_enquiry: "New enquiry",
  information_collection: "Information collection",
  documents_outstanding: "Documents outstanding",
  ready_for_broker: "Ready for broker",
  sent_to_broker: "Sent to broker",
  broker_review: "Broker review",
  application_progressing: "Application progressing",
  offer_received: "Offer received",
  completion_pending: "Completion pending",
  completed: "Completed",
  on_hold: "On hold",
  withdrawn: "Withdrawn",
  declined: "Declined",
};

export const fmtGBP = (n) =>
  `£${Number(n || 0).toLocaleString("en-GB", { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`;

export const fmtDDMMYYYY = (iso) => {
  if (!iso) return "—";
  const d = new Date(iso.length === 10 ? `${iso}T00:00:00` : iso);
  if (isNaN(d)) return "—";
  return `${String(d.getDate()).padStart(2, "0")}/${String(d.getMonth() + 1).padStart(2, "0")}/${d.getFullYear()}`;
};
